import browserDetection from './browserDetection';
import { IS_SERVER } from '../config';

export default function isUnsupportedBrowser() {
  if (IS_SERVER) return false;

  const browserInfo = browserDetection(navigator.userAgent);

  const platform = browserInfo.platform;
  const browser = browserInfo.browser;
  const browserVersion = browserInfo.browserVersion;
  const os = browserInfo.os;

  // Windows Vista === version 6.0
  // Windows 7     === version 6.1
  // Windows 8     === version 6.2
  // Windows 8.1   === version 6.3
  // Windows 10    === version 10
  const osVersion = browserInfo.osVersion;

  // FF < 42
  if (browser === 'firefox' && browserVersion.major < 42) {
    return true;
  }

  // IE <= IE11
  if (browser === 'msie' && browserVersion.major <= 11) {
    return true;
  }

  // Windows Phone 8.1
  if (platform === 'mobile' && os === 'windows' && osVersion.major <= 8) {
    return true;
  }

  // Safari on OSX Mavricks (10.9)
  if (os === 'mac' && browser === 'safari' && osVersion.major === '10' && osVersion.minor <= 9) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/util/isUnsupportedBrowser.js